"use client";
import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";
import { AppSize, pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";

export default function Mission() {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.about}>
        <Typography className={classes.aboutHeading}>About Us</Typography>
        <Box className={classes.aboutSub}>
          <Box className={classes.aboutSum}>
            Arel Homes is a leading real estate development company specializing
            in property construction, architectural design, interior solutions,
            and investment opportunities. With a commitment to innovation,
            transparency, and quality, we create premium properties tailored to
            meet the needs of homeowners, investors, and businesses.
          </Box>
          <Box className={classes.aboutExp}>
            <Typography className={classes.aboutFeature}>
              <span className={classes.aboutSpan}>
                10+ Years of Experience:
              </span>{" "}
              Established presence in the real estate industry.
            </Typography>
            <Typography className={classes.aboutFeature}>
              <span className={classes.aboutSpan}>Core Services:</span> Property
              development, real estate investment, construction, and interior
              design.
            </Typography>{" "}
            <Typography className={classes.aboutFeature}>
              <span className={classes.aboutSpan}>Market Reach:</span> Serving
              clients across Nigeria and beyond.
            </Typography>
            <Typography className={classes.aboutFeature}>
              <span className={classes.aboutSpan}>
                Commitment to Excellence:
              </span>
              Focus on quality, sustainability, and customer satisfaction.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // flexDirection: "column",
    // gap: theme.spacing(4),
    // padding: `0px ${pxToRem(AppSize.padding)}`,
  },
  aboutNav: {
    height: pxToRem(59),
    width: "100%",
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  navTxt: {
    color: AppColors.neutral["48"],
    fontWeight: 500,
    fontSize: pxToRem(20),
  },
  navContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
    border: "1px solid #0C0C0D0D",
    boxShadow: "0px 4px 10px #0C0C0D0D",
    height: pxToRem(59),
    width: pxToRem(469),
  },
  aboutHeading: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    color: AppColors.text.default,
    fontSize: pxToRem(38),
    textAlign: "center",
  },
  aboutSum: {
    fontWeight: 400,
    color: AppColors.text.second,
    fontSize: pxToRem(20),
    display: "flex",
    flex: 1,
    lineHeight: "160%",
    [theme.breakpoints.down("sm")]: {
      // display: "flex",
      // lineHeight: "160%",
      // width: "100%",
    },
  },
  aboutExp: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      gap: theme.spacing(4),
    },
  },
  aboutSpan: {
    fontWeight: 600,
    color: AppColors.text.second,
  },
  aboutFeature: {
    fontWeight: 400,
    color: AppColors.text.second,
    fontSize: pxToRem(20),
  },
  about: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(4),
    gap: theme.spacing(4),
    padding: `0px ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `0px ${pxToRem(20)}`,
    },
  },
  aboutSub: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
}));
